<template>
  <v-container id="template-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10" class="small-icon">
        <base-material-card color="primary" icon="mdi-note-text">
          <v-row>
            <v-col cols="12" md="6" v-if="!id">
              <toggle-button
                @change="emptyTemplate(template.forUpload)"
                v-model="template.forUpload"
                :labels="{ checked: 'For Upload', unchecked: 'For Download' }"
                lg
                :height="30"
                :width="160"
                :font-size="20"
              />
            </v-col>
            <v-col cols="12" md="6" v-if="id">
              <span>{{
                template.forUpload
                  ? $i18n.t("For Upload")
                  : $i18n.t("For Download")
              }}</span>
            </v-col>
          </v-row>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="template.name"
                    :label="$i18n.t('Name')"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    :disabled="!!id"
                    v-model="template.kind"
                    :label="$i18n.t('Kind')"
                    :items="kinds"
                    item-text="name"
                    item-value="value"
                    @change="templateListFunc(template.kind)"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-if="template.forUpload"
                    v-model="template.nonEditable"
                    :label="$i18n.t('Make data non editable')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content class="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Columns") }}</h3>
                        </v-col>
                        <v-spacer />
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr
                          v-for="(item, index) in template.contents"
                          :key="'item' + index"
                        >
                          <td>
                            <v-text-field
                              v-model="item.index"
                              :label="$i18n.t('Column Number')"
                              type="number"
                              disabled
                            />
                          </td>
                          <td>
                            <v-autocomplete
                              v-model="item.field"
                              :label="$i18n.t('Field Mapping')"
                              :items="fields"
                              item-text="name"
                              item-value="_id"
                              @change="updateHeading(item)"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="item.heading"
                              :label="$i18n.t('Heading')"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-if="isTarget(item.field)"
                              type="text"
                              class="form-control"
                              v-model="item.targetHead"
                            />
                          </td>
                          <td>
                            <v-checkbox
                              v-model="item.summable"
                              style="padding: 0; float: left; width: 30px"
                              v-if="template.kind == 5"
                            />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(template.contents, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-btn
                              class="float-right"
                              @click="add(template.contents, index)"
                              fab
                              text
                              small
                              color="blue"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                            <v-btn
                              class="float-right"
                              color="primary"
                              small
                              fab
                              text
                              dark
                              @click="moveUp(template.contents, index)"
                              v-if="index > 0"
                            >
                              <v-icon>mdi-arrow-up</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !template.contents || template.contents.length < 1
                          "
                        >
                          <td>
                            <v-btn
                              class="float-right"
                              @click="add(template.contents, index)"
                              fab
                              text
                              small
                              color="blue"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  template = { contents: [], forUpload: false };
  id = null;
  fields = [];
  kinds = [
    { value: 1, name: "Trip" },
    { value: 2, name: "Invoice" },
    { value: 3, name: "Employee" },
    { value: 4, name: "Vehicle" },
    { value: 5, name: "Invoice Print" },
    { value: 6, name: "Client" },
    { value: 7, name: "Vendor" },
  ];

  updateHeading(content) {
    if (!content || !content.field) {
      content.heading = null;
      return;
    }
    if (!this.fields || this.fields.length == 0 || content.heading) return;
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i]._id === content.field) {
        content.heading = this.fields[i].name;
        content.name = content.heading;
        break;
      }
    }
  }

  emptyTemplate(forUpload) {
    // console.log(forUpload);
    this.template = { contents: [], forUpload: forUpload };
    this.fields = [];
  }

  async templateListFunc(kind) {
    common.setLoading(true);
    try {
      this.fields = await doGet(
        "/api/template/" +
          kind +
          "/" +
          (this.template.forUpload ? 2 : 1) +
          "/list"
      );
      common.setLoading(false);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  get loading() {
    return common.loading;
  }

  validateSave() {
    if (!this.template.name) {
      common.setError("Please enter name");
      return false;
    }

    if (!this.template.kind) {
      common.setError("Please select kind");
      return false;
    }

    if (this.template.contents != null && this.template.contents.length > 0) {
      for (let i = 0; i < this.template.contents.length; i++) {
        if (this.template.contents[i].index == null) {
          common.setError("Please enter index");
          return;
        }
        if (!this.template.contents[i].heading) {
          common.setError("Please enter heading");
          return;
        }
        if (!this.template.contents[i].field) {
          common.setError("Please select field");
          return;
        }

        if (
          this.template.contents[i].field == "B_targetTaxItems" &&
          this.template.contents[i].targetHead
        ) {
          if (!this.template.contents[i].field.includes(".")) {
            this.template.contents[i].field =
              this.template.contents[i].field +
              ".`" +
              this.template.contents[i].targetHead +
              "`";
          }
        }
      }
    }
    return true;
  }

  isTarget(field) {
    if (this.fields) {
      for (let i = 0; i < this.fields.length; i++) {
        const element = this.fields[i];
        if (element._id == field && element.hasTarget)  {
          return true;
        }
      }
    }
    return false;
  }

  async save() {
    try {
      if (!this.validateSave()) return;
      common.setLoading(true);
      let url = "/api/template/edit";
      if (!this.id) url = "/api/template/save";
      const response = await doPost(url, this.template);
      if (!this.id) this.$router.push("/settings/template/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/template/" + id + "/detail");
      if (!response.contents) response.contents = [];
      this.template = response;
      this.id = this.template._id;
      this.templateListFunc(response.kind);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }

  moveUp(list, _index) {
    const item = list[_index];
    list.splice(_index, 1);
    list.splice(_index - 1, 0, item);
    for (let i = 0; i < list.length; i++) {
      list[i].index = i + 1;
    }
  }

  add(list, _index) {
    list.splice(_index + 1, 0, {});
    for (let i = 0; i < list.length; i++) {
      list[i].index = i + 1;
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
